export default __webpack_public_path__ + "75f84d911bb52190ea2507dfc3294dd4.svg";